// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"2993f5e7","605":"fc5c14ea","725":"5f593d51"}[chunkId] + ".chunk.js";
};